module.exports = __webpack_public_path__ + "img/calculator.3d67236c.svg";